import {
    createSlice
} from "@reduxjs/toolkit";

const initialState = {
    notes: {
        data: [],
    },
    allNotes: {
        data: null,
        isLoading: false,
        error: "",
    },
    listingData: null,
};

export const houseCardsHeardNotesSlice = createSlice({
    name: "houseCards",
    initialState,
    reducers: {
        houseCardsHeardNotesFetching(state) {
            state.allNotes.isLoading = true;
            state.allNotes.error = "";
        },
        setHouseCardsHeardNote(state, actions) {
            const oldData = state.notes.data.filter(
                (item) => item.id !== actions.payload.id
            );
            state.notes.data = [
                ...oldData,
                {
                    id: actions.payload.id,
                    value: actions.payload.value
                },
            ];
        },
        houseCardsHeardNotesFetchingError(state, actions) {
            state.allNotes.isLoading = false;
            state.allNotes.error = actions.payload;
        },
        setListingData(state, actions) {
            state.listingData = actions.payload;
        },
    },
});

export default houseCardsHeardNotesSlice.reducer;